import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M18 2.39952V22.7954C18 23.8632 16.7053 24.4031 15.95 23.6473L12.8451 20.5399C12.3776 20.072 11.6224 20.072 11.1548 20.5399L8.04994 23.6473C7.2947 24.4031 6 23.8632 6 22.7954V2.39952C6 1.07978 7.07892 0 8.3976 0H15.5904C16.9211 0 18 1.07978 18 2.39952Z' />
        </SvgIcon>
    );
});
